import React from 'react';

export function twitterShare(story){
    // console.log(story)
    let name = story.name;
    name.replaceAll(" ", "%20")
    let slug = story.full_slug;
    slug.replaceAll("/", "%2F")
    let url = `https://twitter.com/intent/tweet`;
   url += `?url=https%3A%2F%2Fstartresponsible.com%2F${slug}`;
   url += `&text=${name}`;
    url +=`&hastags=css,html`;

    return url;
}
export function linkedinShare(story){
    let name = story.name;
    name.replaceAll(" ", "%20")
    let slug = story.full_slug;
    slug.replaceAll("/", "%2F")
    let excerpt = story.content.excerpt;
    excerpt.replaceAll(" ", "%20");
    let url = `https://www.linkedin.com/sharing/share-offsite/`;
    url += `?url=https://startresponsible.com/${rewriteSlug(slug)}`;

    return url;
}
export function facebookShare(story){
    let name = story.name;
    name.replaceAll(" ", "%20")
    let slug = story.full_slug;
    slug.replaceAll("/", "%2F")
    let url = `https://www.facebook.com/sharer.php`;
    url += `?u=https%3A%2F%2Fstartresponsible.com%2F${rewriteSlug(slug)}`;

    return url;
}
export function linkShare(story){
  const storyURL = `https://www.startresponsible.com/${rewriteSlug(story.full_slug)}/`;

  let body = `${story.content.excerpt}\n${storyURL}`
  let mailto = `mailto:?subject=${encodeURIComponent(story.content.headline)}&body=${encodeURIComponent(body)}`
   
   
  return mailto;
}


function rewriteSlug(slug) {
  const defaultLanguage = "en/";
  let newSlug = slug;
  newSlug = newSlug.replace("home", "");
  newSlug = newSlug.replace(defaultLanguage, "");
  return newSlug;
}